<template>
    <div>
        <div class="content-caption dashed">请购信息</div>
        <div class="simple-form flex col-4">
            <div class="form-group center">
                <div class="form-label">
                    <label>请购单号</label>
                </div>
                <div class="form-value">
                    <span>{{requireVoucher.innerNo || requireVoucher.no}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>购置部门</label>
                </div>
                <div class="form-value">
                    <span>{{requireVoucher.requireBizUnitName || ''}}/{{requireVoucher.requireComName || ''}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>经办人</label>
                </div>
                <div class="form-value">
                    <span>{{requireVoucher.applicantName}}</span>
                </div>
            </div>
            <div class="form-group center" v-if="requireVoucher != null && requireVoucher.itemList != null">
                <div class="form-label">
                    <label>期望到货日期</label>
                </div>
                <div class="form-value">
                    <span>{{requireVoucher.itemList[0].desireArriveDate}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>标题</label>
                </div>
                <div class="form-value">
                    <span>{{requireVoucher.title || ''}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>采购需求</label>
                </div>
                <div class="form-value">
                    <span>{{requireVoucher.desc || ''}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>单独采购组装件</label>
                </div>
                <div class="form-value">
                    <span>{{requireVoucher.onlyForAsmblAcc ? '是' : '否'}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审核意见</label>
                </div>
                <div class="form-value">
                    <span>通过</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>审核描述</label>
                </div>
                <div class="form-value">
                    <span>{{auditDesc}}</span>
                </div>
            </div>
            <!--<div class="form-group center">-->
            <!--<div class="form-label">-->
            <!--<label>自动生成订单</label>-->
            <!--</div>-->
            <!--<div class="form-value">-->
            <!--<span>{{requireVoucher.autoOrderFlag ? '是' : '否'}}</span>-->
            <!--</div>-->
            <!--</div>-->
        </div>
        <template v-if="requireVoucher.goodsFlag && requireVoucher.goodsItemList.length > 0">
            <div class="content-caption dashed">
                <span>请购商品</span>
                <span class="fr" style="font-size: 12px">包含组装件总数：{{totalAsmblAccSetCount || 0}}</span>
                <span class="fr mr10" style="font-size: 12px">含税总金额(元)：{{parseFloat(requireVoucher.wtxAmount || 0).toFixed(2)}}</span>
            </div>
           <el-form :model="requireVoucher" ref="goodsItemList" class="demo-ruleForm">
                <div class="table-layout">
                    <div class="table-layout" style="overflow-x: auto">
                        <table class="custom-tbl">
                            <thead class="head">
                            <tr class="row">
                                <th width="60">序号</th>
                                <th width="180" style="text-align: left" v-if="showAssetInfo">资产定义编码</th>
                                <th width="180" style="text-align: left" v-if="showAssetInfo">资产描述全称</th>
                                <th width="120" style="text-align: left" v-if="showAssetInfo">型号</th>
                                <th width="120" style="text-align: left" v-if="showAssetInfo">规格</th>
                                <th width="120" style="text-align: left" v-if="showAssetInfo">品牌</th>

                                <th width="180" style="text-align: left">名称</th>
                                <th width="120" style="text-align: left">分类名称</th>
                                <th width="120" style="text-align: left" v-if="!showAssetInfo">品牌名称</th>
                                <th width="120" style="text-align: left" v-if="!showAssetInfo">型号</th>
                                <th width="120" style="text-align: left" v-if="!showAssetInfo">规格</th>
                                <th width="60">单位</th>
                                <th width="180" style="text-align: left">供应商</th>
                                <th width="180" style="text-align: left">供方公司</th>
                                <th width="80" v-if="!lowCostFlag">仅组装件</th>
                                <th width="80">采购模式</th>
                                <th width="80">定制商品</th>
                                <th width="110" style="text-align: right">含税价(元)</th>
                                <th width="110" style="text-align: right">含税小计(元)</th>
                                <th width="90" style="text-align: right">税率(%)</th>
                                <th width="110" style="text-align: right">未税价(元)</th>
                                <th width="110" style="text-align: right">包含组装件数量</th>
                                <th width="100" style="text-align: right">申请数量</th>
                                <th width="180" style="text-align: left">操作</th>
                            </tr>
                            </thead>
                            <tbody class="body" v-for="(goodsItem, index) in requireVoucher.goodsItemList">
                            <tr class="row">
                                <td :rowspan="goodsItem.itemList.length + 1">
                                    <span>{{index + 1}}</span>
                                </td>
                                <td style="text-align: left" v-if="showAssetInfo">
                                    <span>{{goodsItem.assetDefNo || ''}}</span>
                                </td>
                                <td style="text-align: left" v-if="showAssetInfo">
                                    <span>{{goodsItem.devcTitle || ''}}</span>
                                </td>
                                <td style="text-align: left" v-if="showAssetInfo">
                                    <span>{{goodsItem.devcModel || ''}}</span>
                                </td>
                                <td style="text-align: left" v-if="showAssetInfo">
                                    <span>{{goodsItem.devcFixedSpec || ''}}</span>
                                </td>
                                <td style="text-align: left" v-if="showAssetInfo">
                                    <span>{{goodsItem.devcBrandName || ''}}</span>
                                </td>

                                <td style="text-align: left">
                                    <span v-if="showAssetInfo">{{goodsItem.devcName || ''}}</span>
                                    <span v-else>{{goodsItem.name || ''}}</span>
                                </td>
                                <td style="text-align: left">
                                    <span v-if="showAssetInfo">{{goodsItem.devcCatName || ''}}</span>
                                    <span v-else>{{goodsItem.goodsCatName || ''}}</span>
                                </td>
                                <td style="text-align: left" v-if="!showAssetInfo">
                                    <span>{{goodsItem.goodsBrandName || ''}}</span>
                                </td>
                                <td style="text-align: left" v-if="!showAssetInfo">
                                    <span>{{goodsItem.model || ''}}</span>
                                </td>
                                <td style="text-align: left" v-if="!showAssetInfo">
                                    <span>{{goodsItem.fixedSpec || ''}}</span>
                                </td>
                                <td>
                                    <span v-if="showAssetInfo">{{goodsItem.devcUnit || ''}}</span>
                                    <span v-else>{{goodsItem.unit || ''}}</span>
                                </td>
                                <td style="text-align: left">
                                    <span>{{goodsItem.vendorName || ''}}</span>
                                </td>
                                <td style="text-align: left">
                                    <span>{{goodsItem.vendorRealComName || ''}}</span>
                                </td>
                                <td v-if="!lowCostFlag">
                                    <span>
                                        <input type="checkbox" :disabled="goodsItem.itemList.length <= 0 || requireVoucher.onlyForAsmblAcc || goodsItem.deviceId == -1" v-model="goodsItem.onlyForAsmblAcc" @change="onlyForAsmblAccChange(index,goodsItem.onlyForAsmblAcc)"/>
                                    </span>
                                </td>
                                <td>
                                    <span v-if="goodsItem.onlyForAsmblAcc">
                                        <el-select v-model="goodsItem.centBuyMode" placeholder="请选择" @change="selectCentBuyMode(index)">
                                            <el-option v-for="item in centBuyModeList" :key="item.value" :label="item.text" :value="item.value"></el-option>
                                        </el-select>
                                    </span>
                                    <span v-else>
                                        <span v-if="goodsItem.centBuyMode">集采</span>
                                        <span v-else>自采</span>
                                    </span>
                                </td>
                                <td>
                                    <span>{{goodsItem.customized ? '是' : '否'}}</span>
                                </td>
                                <td style="text-align: right">
                                    <span v-if="goodsItem.price != null">{{goodsItem.price.toFixed(2)}}</span>
                                    <span v-else>0.00</span>
                                </td>
                                <td style="text-align: right">
                                    <span v-if="goodsItem.wtxAmount != null">{{parseFloat(goodsItem.wtxAmount).toFixed(2)}}</span>
                                    <span v-else>0.00</span>
                                </td>
                                <td style="text-align: right">
                                    <span v-if="goodsItem.taxRate != null">{{goodsItem.taxRate.toFixed(2)}}</span>
                                    <span v-else>0.00</span>
                                </td>
                                <td style="text-align: right">
                                    <span v-if="goodsItem.ntxPrice != null">{{goodsItem.ntxPrice.toFixed(2)}}</span>
                                    <span v-else>0.00</span>
                                </td>
                                <td style="text-align: right">
                                    <span>{{goodsItem.asmblAccSetCount || 0}}</span>
                                </td>
                                <td style="text-align: right">
                                    <el-form-item :prop="'goodsItemList.' + index + '.quantity'">
                                        <el-input type="text" :disabled="goodsItem.onlyForAsmblAcc || goodsItem.customized" v-model.number="goodsItem.quantity" @change="goodsQuantity(index,goodsItem.quantity)"></el-input>
                                    </el-form-item>
                                </td>
                                <td style="text-align: left">
                                    <a class="swb-btn-link" v-if="goodsItem.id == null" @click="removeGoods(index)">移除</a>
                                    <a class="swb-btn-link" v-if="goodsItem.skuId == -1 && goodsItem.deviceId != -1" @click="addAdoptedGoods(index)">添加供应商</a>

                                    <a class="swb-btn-link" v-if="!goodsItem.onlyForAsmblAcc && goodsItem.deviceId != -1" @click="addGoodsItem(index, true)">新增供应商</a>
                                    <a class="swb-btn-link" v-if="goodsItem.skuId != -1 && goodsItem.deviceId != -1" @click="addGoodsItem(index, false)">新增商品</a>

                                    <a class="swb-btn-link" v-if="goodsItem.skuId != -1 && goodsItem.deviceId != -1" @click="updateGoodsItem(index, false)">更换商品</a>
                                    <a class="swb-btn-link" v-if="goodsItem.skuId != -1 && goodsItem.deviceId != -1" @click="updateGoodsItem(index, true)">更换合同</a>

                                    <a class="swb-btn-link" v-if="!lowCostFlag && goodsItem.deviceId != -1" @click="addAsmblAcc(index)">添加组装件</a>
                                    <a class="swb-btn-link" v-if="!lowCostFlag && goodsItem.deviceId == -1" @click="addAsmblAccForVirtual(index)">添加组装件</a>
                                </td>
                            </tr>
                            <tr class="row" v-for="(asmblAccItem, itemIndex) in goodsItem.itemList">
                                <td style="text-align: left" v-if="showAssetInfo">
                                    <span>{{asmblAccItem.accDefNo || ''}}</span>
                                </td>
                                <td style="text-align: left" v-if="showAssetInfo">
                                    <span>{{asmblAccItem.devcTitle || ''}}</span>
                                </td>
                                <td style="text-align: left" v-if="showAssetInfo">
                                    <span>{{asmblAccItem.devcModel || ''}}</span>
                                </td>
                                <td style="text-align: left" v-if="showAssetInfo">
                                    <span>{{asmblAccItem.devcFixedSpec || ''}}</span>
                                </td>
                                <td style="text-align: left" v-if="showAssetInfo">
                                    <span>{{asmblAccItem.devcBrandName || ''}}</span>
                                </td>

                                <td style="text-align: left">
                                    <span v-if="showAssetInfo">{{asmblAccItem.devcName || ''}}</span>
                                    <span v-else>{{asmblAccItem.name || ''}}</span>
                                </td>
                                <td style="text-align: left">
                                    <span v-if="showAssetInfo">{{asmblAccItem.devcCatName || ''}}</span>
                                    <span v-else>{{asmblAccItem.goodsCatName || ''}}</span>
                                </td>
                                <td style="text-align: left" v-if="!showAssetInfo">
                                    <span>{{asmblAccItem.goodsBrandName || ''}}</span>
                                </td>
                                <td style="text-align: left" v-if="!showAssetInfo">
                                    <span>{{asmblAccItem.model || ''}}</span>
                                </td>
                                <td style="text-align: left" v-if="!showAssetInfo">
                                    <span>{{asmblAccItem.fixedSpec || ''}}</span>
                                </td>
                                <td>
                                    <span v-if="showAssetInfo">{{asmblAccItem.devcUnit || ''}}</span>
                                    <span v-else>{{asmblAccItem.unit || ''}}</span>
                                </td>
                                <td>
                                    <span>{{asmblAccItem.customized ? '是' : '否'}}</span>
                                </td>
                                <td style="text-align: left">
                                    <span>{{asmblAccItem.vendorName || ''}}</span>
                                </td>
                                <td style="text-align: left">
                                    <span>{{asmblAccItem.vendorRealComName || ''}}</span>
                                </td>
                                <td>
                                    <span></span>
                                </td>
                                <td>
                                    <span></span>
                                </td>
                                <td style="text-align: right">
                                    <span v-if="asmblAccItem.price != null">{{asmblAccItem.price.toFixed(2)}}</span>
                                    <span v-else>0.00</span>
                                </td>
                                <td style="text-align: right">
                                    <span v-if="asmblAccItem.wtxAmount != null">{{parseFloat(asmblAccItem.wtxAmount).toFixed(2)}}</span>
                                    <span v-else>0.00</span>
                                </td>
                                <td style="text-align: right">
                                    <span v-if="asmblAccItem.taxRate != null">{{asmblAccItem.taxRate.toFixed(2)}}</span>
                                    <span v-else>0.00</span>
                                </td>
                                <td style="text-align: right">
                                    <span v-if="asmblAccItem.ntxPrice != null">{{asmblAccItem.ntxPrice.toFixed(2)}}</span>
                                    <span v-else>0.00</span>
                                </td>
                                <td></td>
                                <td style="text-align: right">
                                    <el-form-item :prop="'goodsItemList.' + index + '.itemList.'+ itemIndex+'.quantity'" :rules="{validator: validateQuantity, trigger: 'blur'}">
                                        <el-input type="text" v-model.number="asmblAccItem.quantity" @change="accQuantity(itemIndex, index)"></el-input>
                                    </el-form-item>
                                </td>
                                <td style="text-align: left">
                                    <a class="swb-btn-link" v-if="asmblAccItem.id == null" @click="removeAccGoods(itemIndex, index)">移除</a>
                                    <a class="swb-btn-link" v-if="asmblAccItem.skuId == null || asmblAccItem.skuId == -1" @click="addAccSku(itemIndex, index)">生成入选商品</a>
                                    <a class="swb-btn-link" v-if="asmblAccItem.skuId == null || asmblAccItem.skuId == -1" @click="selectAdoptedGoods(itemIndex, index)">关联商品</a>
                                    <a class="swb-btn-link" v-if="asmblAccItem.vendorId != -1" @click="addAccGoods(itemIndex, index)">新增供应商</a>

                                    <a class="swb-btn-link" v-if="asmblAccItem.skuId != -1" @click="updateAccGoods(itemIndex, index)">更换合同</a>
                                </td>
                            </tr>
                            </tbody>
                            <tbody class="body" v-if="requireVoucher.goodsItemList == null || requireVoucher.goodsItemList.length <= 0">
                            <tr class="row">
                                <td colspan="16" style="text-align: center; line-height: 40px;">
                                    <span>暂无数据...</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
        </template>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { goodsInSelectDlg, servcInSelectDlg, goodsInSelectGroupDlg } from './dialog'
    import { openVendorSelectComnDlg } from '../vendor/selectDlg'
    import { openSkuListSelectDlg } from '../goods/selectDlg'
    import { showAsmblAccDefSelectDlg } from '../asmblAcc/dialog'
    import { getMerchantBizParam } from '../asset/assetMain'

    import devcReqrApi from '../../api/devcReqr'
    import devcDefApi from '../../api/devcDef'
    import retailerApi from '../../api/retailer'

    export default {
        name: 'swb-device-require-voucher-update',
        desc: '设备请购单项列表',
        props: ['id', "auditDesc", "autoOrderFlag"],
        data: function () {
            return {
                requireVoucher: {},
                bizFormId: null,
                bizAreaId: null,
                lowCostFlag: false,
                centBuyModeList: [{"value": true, text: '集采'}, {"value": false, text: "自采"}],
                showAssetInfo: false,
                totalAsmblAccSetCount: 0,
            }
        },
        created: function () {
            let self = this;
            // 交易中是否展示资产相关信息
            getMerchantBizParam("display.asset.related.info.in.trading", function (result) {
                self.showAssetInfo = Utils.isTrue(result);
            });
            //
            this.getRequireGoodsItem();
        },
        methods: {
            getRequireGoodsItem: function () {
                let self = this;
                let postData = {id: self.id};
                devcReqrApi.getDeviceRequireVoucherInfo(postData, function (result) {
                    if(result.type === "info") {
                        let requireVoucher = result.data;

                        let goodsItemList = requireVoucher.goodsItemList || [];
                        for(let i = 0; i < goodsItemList.length; i++) {
                            let goodsItem = goodsItemList[i];
                            goodsItem.reqCentBuyMode = goodsItem.centBuyMode;
                            let itemList = goodsItem.itemList || [];
                            for(let j = 0; j < itemList.length; j++) {
                                let item = itemList[j];
                                if(goodsItem.quantity == 0) {
                                    item.setQuantity = item.quantity;
                                } else {
                                    item.setQuantity = item.quantity / goodsItem.quantity;
                                }
                            }
                        }
                        requireVoucher.goodsItemList = Utils.merge([], goodsItemList);
                        if(!Utils.isNoB(self.autoOrderFlag)) {
                            requireVoucher.autoOrderFlag = self.autoOrderFlag;
                        }
                        self.requireVoucher = requireVoucher;
                        self.lowCostFlag = requireVoucher.stuffFlag; // 选择耗材
                        //
                        self.getRetailerComId(requireVoucher.requireComId);
                        // 包含组装件总数
                        self.countTotalAsmblAccSetCount();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            countTotalAsmblAccSetCount(){
                let deviceRequireVoucher = this.requireVoucher;
                let goodsItemList = deviceRequireVoucher.goodsItemList;
                let totalAsmblAccSetCount = 0;
                goodsItemList.forEach(function (theItem) {
                    if (!Utils.isNoB(theItem.asmblAccSetCount)) {
                        totalAsmblAccSetCount = totalAsmblAccSetCount + theItem.asmblAccSetCount;
                    }
                });
                this.totalAsmblAccSetCount = totalAsmblAccSetCount;
            },
            getRetailerComId: function (comId) {
                let self = this;
                let postData = {
                    comId: comId
                };
                retailerApi.getRetailerCom(postData, function (result) {
                    if(result.type == "info") {
                        let retailerCom = result.data;
                        self.bizFormId = retailerCom.bizFormId;
                        self.bizAreaId = retailerCom.bizAreaId;
                    }
                })
            },
            validateQuantity: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('请输入申请数量'));
                } else {
                    if(!Utils.isNumber(value) || value < 0) {
                        callback(new Error('请输入大于0的数字'));
                    } else {
                        callback();
                    }
                }
            },
            // 计算含税总金额
            calWtxAmount: function () {
                let requireVoucher = this.requireVoucher || {};
                let goodsItemList = requireVoucher.goodsItemList || [];
                // 计算含税总金额
                let wtxAmount = 0;
                for(let i = 0, len = goodsItemList.length; i < len; i++) {
                    let goodsItemInfo = goodsItemList[i];
                    wtxAmount += parseFloat(goodsItemInfo.wtxAmount || 0);
                    // 组装件列表
                    let accItemList = goodsItemInfo.itemList || [];
                    for(let j = 0, a = accItemList.length; j < a; j++) {
                        let accItem = accItemList[j];
                        wtxAmount += parseFloat(accItem.wtxAmount || 0);
                    }
                }
                this.requireVoucher.wtxAmount = wtxAmount.toFixed(2);
            },
            removeGoods: function (index) {
                let self = this;
                let goodsItemList = self.requireVoucher.goodsItemList;
                this.$confirm('确定删除此商品?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    goodsItemList.splice(index, 1);
                    self.requireVoucher.goodsItemList = Utils.merge([], goodsItemList);
                    // 包含组装件总数
                    self.countTotalAsmblAccSetCount();
                    // 计算含税总金额
                    self.calWtxAmount();
                }).catch(function () {
                });
            },
            // 组装请购商品项
            makeGodsItemInfo: function (deviceRequirer) {
                let item = {};
                item.deviceId = deviceRequirer.id;
                item.devcBrandName = deviceRequirer.devcBrandName;
                item.devcModel = deviceRequirer.devcModel;
                item.devcFixedSpec = deviceRequirer.devcFixedSpec;
                item.devcUnit = deviceRequirer.devcUnit;
                item.assetDefNo = deviceRequirer.innerCode;
                item.oldCustomized = deviceRequirer.customized;
                item.customized = deviceRequirer.customized;
                //
                item.name = deviceRequirer.name;
                item.title = deviceRequirer.name;
                item.asmblAccFlag = deviceRequirer.asmblAccFlag;
                item.vendorId = deviceRequirer.vendorId;
                item.vendorName = deviceRequirer.vendorName;
                item.centBuyMode = deviceRequirer.centBuyMode;
                item.reqCentBuyMode = deviceRequirer.centBuyMode;
                item.skuId = deviceRequirer.skuId;
                item.centBuyMode = deviceRequirer.centBuyMode;
                item.assetDefId = deviceRequirer.assetDefId;
                item.model = deviceRequirer.model;
                item.fixedSpec = deviceRequirer.fixedSpec;
                item.modelSpec = deviceRequirer.modelSpec;
                item.goodsCatId = deviceRequirer.goodsCatId;
                item.goodsBrandId = deviceRequirer.goodsBrandId;
                item.goodsCatName = deviceRequirer.goodsCatName;
                item.goodsBrandName = deviceRequirer.goodsBrandName;
                item.unit = deviceRequirer.unit;
                if(Utils.isTrue(deviceRequirer.contractEnded)) {
                    item.contractId = -1;
                } else {
                    item.contractTitle = deviceRequirer.contractTitle;
                    item.contractId = deviceRequirer.contractId;
                    item.contractDateStart = deviceRequirer.contractDateStart;
                    item.contractDateEnd = deviceRequirer.contractDateEnd;
                }
                item.quantity = 1;
                item.price = deviceRequirer.price;
                item.ntxPrice = deviceRequirer.ntxPrice;
                item.wtxAmount = (parseFloat(item.price || 0) * parseInt(item.quantity)).toFixed(2);
                item.taxRate = deviceRequirer.taxRate;
                item.itemList = [];
                //
                return item;
            },
            addGoodsItem: function (index, voucherFlag) {
                let self = this;
                let requireVoucher = self.requireVoucher;
                let goodsItemList = requireVoucher.goodsItemList || [];
                let goodsItem = goodsItemList[index];
                let itemIds = goodsItemList.pluck("deviceId");
                let centBuyMode = true;
                if(Utils.isFalse(requireVoucher.centBuyMode)) {
                    centBuyMode = false;
                }
                let bizAreaId = self.bizAreaId != null ? self.bizAreaId : -1;
                let bizFormId = self.bizFormId != null ? self.bizFormId : -1;
                let filter = {
                    assetDefFlag: true,
                    catId: goodsItem.goodsCatId,
                    brandId: goodsItem.goodsBrandId,
                    goodsModel: goodsItem.model,
                    bizAreaId: bizAreaId,
                    bizAreaFlag: true,
                    bizFormFlag: true,
                    bizFormId: bizFormId,
                    vendorId: goodsItem.vendorId,
                    voucherFlag: voucherFlag,
                    disabled: false,
                };
                let params = {};
                params.filter = filter;
                params.checkIds = itemIds;
                params.centBuyMode = centBuyMode;
                params.showTable = true;
                params.title = voucherFlag ? "供应商-选择" : "商品-选择";
                params.showCatBrandTable = true;
                params.showCatBrandModelTable = true;
                params.showCatTable = true;
                params.lowCostFlag = requireVoucher.stuffFlag;
                goodsInSelectDlg(params, function (result) {
                    let itemList = result || [];
                    let deviceIds = [];
                    for(let i = 0; i < itemList.length; i++) {
                        let deviceRequirer = itemList[i];
                        index = index + 1;
                        let item = self.makeGodsItemInfo(deviceRequirer);
                        item.centBuyMode = centBuyMode;
                        //
                        if(itemIds.indexOf(item.deviceId) > -1) {
                            MsgBox.warning(item.name + "已经包含，不可再次添加");
                            return;
                        }
                        goodsItemList.splice(index, 0, item);
                        //
                        deviceIds.push(deviceRequirer.id);
                    }
                    if (deviceIds.length > 0 && !Utils.isTrue(requireVoucher.onlyForAsmblAcc)) {
                        self.getAccDefList(deviceIds);
                    }
                    self.requireVoucher.goodsItemList = Utils.merge([], goodsItemList);
                    // 计算含税总金额
                    self.calWtxAmount();
                    // 包含组装件总数
                    self.countTotalAsmblAccSetCount();
                });
            },
            updateGoodsItem: function (index, changeContractFlag) {
                let self = this;
                let requireVoucher = self.requireVoucher;
                let goodsItemList = requireVoucher.goodsItemList || [];
                let goodsItem = goodsItemList[index];
                // 记录更换前的数量
                let afterQuantity = goodsItem.quantity || 1;
                //
                let itemIds = goodsItemList.pluck("deviceId");
                let centBuyMode = true;
                if(Utils.isFalse(requireVoucher.centBuyMode)) {
                    centBuyMode = false;
                }
                let bizAreaId = self.bizAreaId != null ? self.bizAreaId : -1;
                let bizFormId = self.bizFormId != null ? self.bizFormId : -1;
                let filter = {
                    contractRealComId: requireVoucher.requireRealComId,
                    assetDefFlag: true,
                    catId: goodsItem.goodsCatId,
                    brandId: goodsItem.goodsBrandId,
                    goodsModel: goodsItem.model,
                    bizAreaId: bizAreaId,
                    bizAreaFlag: true,
                    bizFormFlag: true,
                    bizFormId: bizFormId,
                    vendorId: goodsItem.vendorId,
                    voucherFlag: false,
                    disabled: false,
                    retailerId: requireVoucher.retailerId
                };
                let params = {};
                params.checkIds = itemIds;
                params.title = "商品-选择";
                params.centBuyMode = centBuyMode;
                params.showTable = true;
                params.showCatBrandTable = true;
                params.showCatBrandModelTable = true;
                params.showCatTable = true;
                params.lowCostFlag = requireVoucher.stuffFlag;
                params.checkBox = false;
                params.showCentBuyFlag = false;
                if(Utils.isTrue(changeContractFlag)) {  // 更换合同，同供应商、同定义
                    filter = {
                        contractRealComId: requireVoucher.requireRealComId,
                        assetDefFlag: true,
                        assetDefId: goodsItem.assetDefId,
                        vendorId: goodsItem.vendorId,
                        voucherFlag: false,
                        disabled: false,
                        retailerId: requireVoucher.retailerId,
                        contractEnded: false
                    };
                    params.showTable = false;
                }
                params.filter = filter;
                goodsInSelectDlg(params, function (result, theDlg) {
                    let deviceRequirer = result;
                    // 检查是否有重复信息  "assetDefId", "deviceId", "skuId", "vendorId", "contractId"
                    let validFlag = false;
                    for(let i = 0; i < goodsItemList.length; i++) {
                        let goodsItemInfo = goodsItemList[i];
                        if(goodsItemInfo.assetDefId == deviceRequirer.assetDefId && goodsItemInfo.deviceId == deviceRequirer.id && //
                            goodsItemInfo.skuId == deviceRequirer.skuId && goodsItemInfo.vendorId == deviceRequirer.vendorId && //
                            goodsItemInfo.contractId == deviceRequirer.contractId) {
                            //
                            validFlag = true;
                            MsgBox.warning("当前选择的资产已存在，请修改");
                            break;
                        }
                    }
                    if(validFlag) {
                        return;
                    } else {
                        theDlg.close();
                    }
                    //
                    let item = self.makeGodsItemInfo(deviceRequirer);
                    item.requireComId = goodsItem.requireComId;
                    item.requireComName = goodsItem.requireComName;
                    item.requireComLevel = goodsItem.requireComLevel;
                    item.centBuyMode = centBuyMode;
                    item.quantity = afterQuantity;
                    //
                    item.itemList = [];
                    goodsItemList[index] = Utils.merge({}, item);
                    //
                    let deviceIds = [];
                    deviceIds.push(deviceRequirer.id);
                    self.getAccDefList(deviceIds);
                    self.requireVoucher.goodsItemList = Utils.merge([], goodsItemList);
                    // 计算含税总金额
                    self.calWtxAmount();
                    // 包含组装件总数
                    self.countTotalAsmblAccSetCount();
                });
            },
            //
            makeAccGoodsInfo: function (deviceRequirer) {
                let item = {};
                item.deviceId = deviceRequirer.id;
                item.devcBrandName = deviceRequirer.devcBrandName;
                item.devcModel = deviceRequirer.devcModel;
                item.devcFixedSpec = deviceRequirer.devcFixedSpec;
                item.devcUnit = deviceRequirer.devcUnit;
                item.accDefNo = deviceRequirer.innerCode;
                item.customized = deviceRequirer.customized;
                item.name = deviceRequirer.name;
                item.asmblAccFlag = deviceRequirer.asmblAccFlag;
                item.vendorId = deviceRequirer.vendorId;
                item.vendorName = deviceRequirer.vendorName;
                item.centBuyMode = deviceRequirer.centBuyMode;
                item.skuId = deviceRequirer.skuId;
                item.accDefId = deviceRequirer.assetDefId;
                item.model = deviceRequirer.model;
                item.fixedSpec = deviceRequirer.fixedSpec;
                item.modelSpec = deviceRequirer.modelSpec;
                item.goodsCatId = deviceRequirer.goodsCatId;
                item.goodsBrandId = deviceRequirer.goodsBrandId;
                item.goodsCatName = deviceRequirer.goodsCatName;
                item.goodsBrandName = deviceRequirer.goodsBrandName;
                item.unit = deviceRequirer.unit;
                item.price = deviceRequirer.price;
                item.ntxPrice = deviceRequirer.ntxPrice;
                item.taxRate = deviceRequirer.taxRate;
                if(Utils.isTrue(deviceRequirer.contractEnded)) {
                    item.contractId = -1;
                } else {
                    item.contractTitle = deviceRequirer.contractTitle;
                    item.contractId = deviceRequirer.contractId;
                    item.contractDateStart = deviceRequirer.contractDateStart;
                    item.contractDateEnd = deviceRequirer.contractDateEnd;
                }
                item.quantity = 1;
                item.wtxAmount = (parseFloat(item.price || 0) * parseInt(item.quantity)).toFixed(2);
                item.setQuantity = 1;
                return item;
            },
            addAccGoods: function (index, goodsIndex) {
                let self = this;
                let goodsItemList = self.requireVoucher.goodsItemList || [];
                let goodsItem = goodsItemList[goodsIndex];
                let itemList = goodsItem.itemList;
                let dbItem = itemList[index];
                let itemIds = itemList.pluck("deviceId");
                let vendorId = dbItem.vendorId;
                if(Utils.isNoB(dbItem.vendorId)) {
                    vendorId = -1
                }
                let bizAreaId = self.bizAreaId != null ? self.bizAreaId : -1;
                let bizFormId = self.bizFormId != null ? self.bizFormId : -1;
                let filter = {
                    assetAccFlag: true,
                    catId: dbItem.goodsCatId,
                    brandId: dbItem.goodsBrandId,
                    bizAreaId: bizAreaId,
                    bizAreaFlag: true,
                    bizFormFlag: true,
                    skuFlag: true,
                    bizFormId: bizFormId,
                    goodsModel: dbItem.model,
                    vendorId: vendorId,
                    voucherFlag: true,
                    disabled: false,
                };
                let params = {};
                params.filter = filter;
                params.checkIds = itemIds;
                params.showTable = true;
                params.showCatBrandTable = true;
                params.showCatBrandModelTable = true;
                params.showCatTable = true;
                goodsInSelectDlg(params, function (result) {
                    let resultItemList = result || [];
                    resultItemList.forEach(function (deviceRequirer) {
                        index = index + 1;
                        if(itemIds.indexOf(deviceRequirer.id) > -1) {
                            MsgBox.warning(deviceRequirer.name + "已经包含，不可再次添加");
                            return;
                        }
                        let item = this.makeAccGoodsInfo(deviceRequirer);
                        //
                        itemList.splice(index, 0, item);
                    });
                    goodsItem.itemList = Utils.merge([], itemList);
                    self.requireVoucher.goodsItemList = Utils.merge([], goodsItemList);
                    // 计算含税总金额
                    self.calWtxAmount();
                });
            },
            //
            updateAccGoods: function (index, goodsIndex) {
                let self = this;
                let goodsItemList = self.requireVoucher.goodsItemList || [];
                let goodsItem = goodsItemList[goodsIndex];
                let itemList = goodsItem.itemList;
                let itemIds = itemList.pluck("deviceId");
                //
                let dbItem = itemList[index];
                let vendorId = dbItem.vendorId;
                if(Utils.isNoB(dbItem.vendorId)) {
                    vendorId = -1
                }
                let filter = {
                    contractRealComId: self.requireVoucher.requireRealComId,
                    assetAccFlag: true,
                    assetDefId: dbItem.accDefId,
                    vendorId: vendorId,
                    voucherFlag: false,
                    disabled: false,
                    asmblAccFlag: true,
                    retailerId: self.requireVoucher.retailerId,
                };
                let params = {};
                params.filter = filter;
                params.checkIds = itemIds;
                params.checkBox = false;
                params.showTable = false;
                //
                goodsInSelectDlg(params, function (result) {
                    let resultItemList = result || [];
                    resultItemList.forEach(function (deviceRequirer) {
                        index = index + 1;
                        if(itemIds.indexOf(deviceRequirer.id) > -1) {
                            MsgBox.warning(deviceRequirer.name + "已经包含，不可再次添加");
                            return;
                        }
                        let item = this.makeAccGoodsInfo(deviceRequirer);
                        //
                        itemList.splice(index, 0, item);
                    });
                    goodsItem.itemList = Utils.merge([], itemList);
                    self.requireVoucher.goodsItemList = Utils.merge([], goodsItemList);
                    // 计算含税总金额
                    self.calWtxAmount();
                });
            },
            // 根据入选商品查询对应的组装件信息
            getAccDefList: function (deviceIds) {
                let self = this;
                let goodsItemList = self.requireVoucher.goodsItemList;
                let postData = {
                    deviceIds: deviceIds,
                    bizAreaId: self.bizAreaId,
                    bizFormId: self.bizFormId
                };
                devcReqrApi.getAdoptedDeviceAsmblAccList(postData, function (result) {
                    if(result.type == "info") {
                        let itemMap = result.data || {};
                        for(let i = 0; i < goodsItemList.length; i++) {
                            let goodsItem = goodsItemList[i];
                            if(deviceIds.indexOf(goodsItem.deviceId) > -1) {
                                let itemList = itemMap[goodsItem.deviceId] || [];
                                let quantity = 0;
                                itemList.forEach(function (item) {
                                    quantity = quantity + item.quantity;
                                    item.setQuantity = item.quantity;
                                    item.wtxAmount = (parseFloat(item.price || 0) * parseInt(item.quantity || 0)).toFixed(2);
                                });
                                goodsItem.asmblAccReqCount = quantity;
                                goodsItem.asmblAccSetCount = quantity;
                                goodsItem.itemList = Utils.merge([], itemList);
                            }
                        }
                        self.requireVoucher.goodsItemList = Utils.merge([], goodsItemList);
                        // 计算含税总金额
                        self.calWtxAmount();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 入选商品的数量修改
            goodsQuantity: function (index, quantity) {
                let requireVoucher = this.requireVoucher;
                let goodsItemList = requireVoucher.goodsItemList;
                let goodsItem = goodsItemList[index];
                if(!Utils.isNumber(quantity) || quantity < 0) {
                    MsgBox.warning('请输入大于0的数字');
                    return;
                }
                goodsItem.wtxAmount = (parseFloat(goodsItem.price || 0) * parseInt(goodsItem.quantity)).toFixed(2);
                //
                let itemList = goodsItem.itemList || [];
                let asmblAccSetCount = 0;
                let asmblAccReqCount = 0;
                for(let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    if(!Utils.isNoB(item.quantity)) {
                        asmblAccSetCount = parseInt(asmblAccSetCount) + parseInt(item.quantity);
                        asmblAccReqCount = parseInt(asmblAccReqCount) + item.quantity;
                        item.wtxAmount = (parseFloat(item.price || 0) * parseInt(item.quantity)).toFixed(2);
                    }
                }
                goodsItem.asmblAccSetCount = asmblAccSetCount;
                goodsItem.asmblAccReqCount = asmblAccReqCount;
                this.requireVoucher.goodsItemList = Utils.merge([], goodsItemList);
                // 计算含税总金额
                this.calWtxAmount();
                // 包含组装件总数
                this.countTotalAsmblAccSetCount();
            },
            // 组装件数量修改
            accQuantity: function (index, goodsIndex) {
                let requireVoucher = this.requireVoucher;
                let goodsItemList = requireVoucher.goodsItemList;
                let goodsItem = goodsItemList[goodsIndex];
                let itemList = goodsItem.itemList || [];
                let item = itemList[index];
                if(!Utils.isNumber(item.quantity) || item.quantity < 0) {
                    MsgBox.warning('请输入大于0的数字');
                    return;
                }
                let asmblAccSetCount = 0;
                let asmblAccReqCount = 0;
                for(let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    if(!Utils.isNoB(item.quantity)) {
                        if(Utils.isTrue(goodsItem.onlyForAsmblAcc)) {
                            asmblAccSetCount = parseInt(asmblAccSetCount) + parseInt(item.quantity);
                            asmblAccReqCount = parseInt(asmblAccReqCount) + parseInt(item.reqQuantity);
                        } else {
                            asmblAccSetCount = parseInt(asmblAccSetCount) + parseInt(item.quantity);
                            asmblAccReqCount = parseInt(asmblAccReqCount) + parseInt(item.reqQuantity);
                        }
                        item.wtxAmount = (parseFloat(item.price || 0) * parseInt(item.quantity || 0)).toFixed(2);
                    }
                }
                goodsItem.asmblAccSetCount = asmblAccSetCount;
                goodsItem.asmblAccReqCount = asmblAccReqCount;
                this.requireVoucher.goodsItemList = Utils.merge([], goodsItemList);
                // 计算含税总金额
                this.calWtxAmount();
                // 包含组装件总数
                this.countTotalAsmblAccSetCount();
            },
            // 入围商品选择供应商
            addAdoptedGoods: function (index) {
                let self = this;
                let requireVoucher = this.requireVoucher;
                let goodsItemList = requireVoucher.goodsItemList;
                let goodsItem = goodsItemList[index];
                openVendorSelectComnDlg(this, {showContract: true, showOrder: true, showBizRel: true, multiSelect: false}, function (voucherResult) {
                    let voucherId = voucherResult.checkedId;
                    //
                    let catId = goodsItem.goodsCatId;
                    openSkuListSelectDlg(false, {
                        merchantId: voucherId,
                        merchantType: getEnumInfoWith("merchantType", "name", "Vendor").value,
                        catId: catId,
                        brandId: goodsItem.goodsBrandId,
                        saleHalted : false
                    }, [], function (mkuResult) {
                        let skuId = mkuResult.id;
                        goodsItem.skuId = skuId;
                        goodsItem.vendorId = voucherId;
                        goodsItem.vendorName = voucherResult.checkedList.name;
                        goodsItem.model = mkuResult.model;
                        goodsItem.fixedSpec = mkuResult.fixedSpec;
                        self.getContractGoodsItem(voucherId, skuId, null, function (result) {
                            if(result != null) {
                                goodsItem.price = result.price;
                                goodsItem.vendorId = voucherId;
                                goodsItem.ntxPrice = result.ntxPrice;
                                goodsItem.taxRate = result.taxRate;
                                goodsItem.contractId = result.contractId;
                                goodsItem.contractDateStart = result.dateStart;
                                goodsItem.contractDateEnd = result.dateEnd;
                                goodsItem.contractNo = result.no;
                            } else {
                                goodsItem.price = mkuResult.salePrice;
                                goodsItem.ntxPrice = mkuResult.salePrice;
                            }
                            goodsItem.wtxAmount = (parseFloat(goodsItem.price || 0) * parseInt(goodsItem.quantity || 0)).toFixed(2);
                            //
                            let postData = {};
                            postData = goodsItem;
                            postData.id = goodsItem.deviceId;
                            postData.bizFormId = self.bizFormId != null ? self.bizFormId : -1;
                            postData.bizAreaId = self.bizAreaId != null ? self.bizAreaId : -1;
                            devcReqrApi.updateAdoptedDeviceSku(postData, function (result) {
                                if(result.type == "info") {
                                    MsgBox.success("添加成功");
                                    self.requireVoucher.goodsItemList = goodsItemList;
                                    // 计算含税总金额
                                    self.calWtxAmount();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            })
                        })
                    })
                })
            },
            // 组装件选择商品
            addAccSku: function (index, goodIndex) {
                let self = this;
                let requireVoucher = this.requireVoucher;
                let goodsItemList = requireVoucher.goodsItemList;
                let goodsItem = goodsItemList[goodIndex];
                let itemList = goodsItem.itemList;
                let item = itemList[index];
                openVendorSelectComnDlg(this, {showContract: true, showOrder: true, showBizRel: true, multiSelect: false}, function (voucherResult) {
                    let voucherId = voucherResult.checkedId;
                    //
                    openSkuListSelectDlg(false, {
                        merchantId: voucherId,
                        merchantType: getEnumInfoWith("merchantType", "name", "Vendor").value,
                        catId: item.goodsCatId,
                        brandId: item.goodsBrandId,
                        saleHalted : false
                    }, [], function (mkuResult) {
                        let skuId = mkuResult.id;
                        item.skuId = skuId;
                        item.vendorId = voucherId;
                        item.vendorName = voucherResult.checkedList.name;
                        item.model = mkuResult.model;
                        item.fixedSpec = mkuResult.fixedSpec;
                        item.bizFormId = self.bizFormId != null ? self.bizFormId : -1;
                        item.bizAreaId = self.bizAreaId != null ? self.bizAreaId : -1;
                        item.assetDefId = item.accDefId;
                        item.asmblAccFlag = true;
                        self.getContractGoodsItem(voucherId, skuId, goodsItem.contractId, function (result) {
                            if(result != null) {
                                item.skuId = skuId;
                                item.vendorId = voucherId;
                                item.vendorName = voucherResult.checkedList.name;
                                item.model = mkuResult.model;
                                item.fixedSpec = mkuResult.fixedSpec;
                                item.bizFormId = self.bizFormId != null ? self.bizFormId : -1;
                                item.bizAreaId = self.bizAreaId != null ? self.bizAreaId : -1;
                                item.assetDefId = item.accDefId;
                                item.asmblAccFlag = true;
                                item.price = result.price;
                                item.ntxPrice = result.ntxPrice;
                                item.taxRate = result.taxRate;
                                item.contractId = result.contractId;
                                item.contractDateStart = result.dateStart;
                                item.contractDateEnd = result.dateEnd;
                                item.contractNo = result.no;
                            } else {
                                item.price = mkuResult.salePrice;
                                item.ntxPrice = mkuResult.salePrice;
                            }
                            item.wtxAmount = (parseFloat(item.price || 0) * parseInt(item.quantity || 0)).toFixed(2);
                            //
                            devcReqrApi.updateAdoptedDevice(item, function (result) {
                                if(result.type == "info") {
                                    MsgBox.success("添加成功");
                                    item.deviceId = result.data;
                                    goodsItem.itemList = Utils.merge([], itemList);
                                    self.requireVoucher.goodsItemList = goodsItemList;
                                    // 计算含税总金额
                                    self.calWtxAmount();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            })

                        })
                    })
                })
            },
            selectAdoptedGoods: function (index, goodsIndex) {
                let self = this;
                let goodsItemList = self.requireVoucher.goodsItemList || [];
                let goodsItem = goodsItemList[goodsIndex];
                let itemList = goodsItem.itemList;
                let item = itemList[index];
                let bizAreaId = self.bizAreaId != null ? self.bizAreaId : -1;
                let bizFormId = self.bizFormId != null ? self.bizFormId : -1;
                let filter = {
                    asmblAccFlag: true,
                    bizAreaId: bizAreaId,
                    bizFormId: bizFormId,
                    bizAreaFlag: true,
                    bizFormFlag: true,
                    catId: item.goodsCatId,
                    brandId: item.goodsBrandId,
                    goodsModel: item.model,
                };
                let params = {};
                params.filter = filter;
                params.skuFlag = true;
                params.checkBox = false;
                params.showTable = true;
                params.showCatBrandTable = true;
                params.showCatBrandModelTable = true;
                params.showAccFlag = true;
                goodsInSelectDlg(params, function (result) {
                    item.deviceId = result.id;
                    item.devcBrandName = result.devcBrandName;
                    item.devcModel = result.devcModel;
                    item.devcFixedSpec = result.devcFixedSpec;
                    item.devcUnit = result.devcUnit;
                    item.assetDefNo = result.innerCode;
                    item.customized = result.customized;

                    item.name = result.name;
                    item.asmblAccFlag = result.asmblAccFlag;
                    item.centBuyMode = result.centBuyMode;
                    item.skuId = result.skuId;
                    item.title = result.title;
                    item.bizAreaCode = result.bizAreaCode;
                    item.bizFormCode = result.bizFormCode;
                    item.vendorName = result.vendorName;
                    item.vendorId = result.vendorId;
                    if(Utils.isTrue(result.contractEnded)) {
                        item.contractId = -1;
                    } else {
                        item.contractTitle = result.contractTitle;
                        item.contractId = result.contractId;
                        item.contractDateStart = result.contractDateStart;
                        item.contractDateEnd = result.contractDateEnd;
                    }

                    item.model = result.model;
                    item.fixedSpec = result.fixedSpec;
                    item.modelSpec = result.modelSpec;
                    item.price = result.price;
                    item.ntxPrice = result.ntxPrice;
                    item.taxRate = result.taxRate;
                    item.wrntPeriod = result.wrntPeriod;
                    item.arriveDays = result.arriveDays;
                    item.goodsCatName = result.goodsCatName;
                    item.goodsBrandName = result.goodsBrandName;
                    item.unit = result.unit;
                    item.wtxAmount = (parseFloat(item.price || 0) * parseInt(item.quantity || 0)).toFixed(2);
                    goodsItem.itemList = Utils.merge([], itemList);
                    self.requireVoucher.goodsItemList = Utils.merge([], goodsItemList);
                    // 计算含税总金额
                    self.calWtxAmount();
                });
            },
            // 是否只有组装件
            onlyForAsmblAccChange(index, onlyForAsmblAcc){
                let requireVoucher = this.requireVoucher;
                let goodsItemList = requireVoucher.goodsItemList;
                let goodsItem = goodsItemList[index];
                let itemList = goodsItem.itemList;
                goodsItem.quantity = null;
                let asmblAccSetCount = 0;
                let asmblAccReqCount = 0;
                for(let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    if(!Utils.isNoB(item.quantity)) {
                        asmblAccSetCount = parseInt(asmblAccSetCount) + parseInt(item.quantity);
                        asmblAccReqCount = parseInt(asmblAccReqCount) + parseInt(item.reqQuantity);
                        item.wtxAmount = (parseFloat(item.price || 0) * parseInt(item.quantity || 0)).toFixed(2);
                    }
                }
                goodsItem.wtxAmount = 0.00;
                goodsItem.centBuyMode = goodsItem.reqCentBuyMode;
                goodsItem.asmblAccSetCount = asmblAccSetCount;
                goodsItem.asmblAccReqCount = asmblAccReqCount;
                goodsItem.itemList = Utils.merge([], itemList);
                this.requireVoucher.goodsItemList = Utils.merge([], goodsItemList);
                // 计算含税总金额
                this.calWtxAmount();
            },
            // 删除入选商品的组装件
            removeAccGoods(index, goodsIndex){
                let requireVoucher = this.requireVoucher;
                let goodsItemList = requireVoucher.goodsItemList;
                let goodsItem = goodsItemList[goodsIndex];
                let itemList = goodsItem.itemList;
                itemList.splice(index, 1);
                let asmblAccSetCount = 0;
                let asmblAccReqCount = 0;
                for(let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    if(Utils.isTrue(goodsItem.onlyForAsmblAcc)) {
                        asmblAccSetCount = parseInt(asmblAccSetCount) + parseInt(item.quantity);
                        asmblAccReqCount = parseInt(asmblAccReqCount) + parseInt(item.reqQuantity);
                    } else {
                        asmblAccSetCount = parseInt(asmblAccSetCount) + (parseInt(item.quantity) * parseInt(goodsItem.quantity));
                        asmblAccReqCount = parseInt(asmblAccReqCount) + (parseInt(item.reqQuantity) * parseInt(goodsItem.quantity));
                    }
                }
                goodsItem.asmblAccSetCount = asmblAccSetCount;
                goodsItem.asmblAccReqCount = asmblAccReqCount;
                goodsItem.itemList = Utils.merge([], itemList);
                requireVoucher.goodsItemList = Utils.merge({}, goodsItemList);
                this.requireVoucher = Utils.merge({}, requireVoucher);
                // 计算含税总金额
                this.calWtxAmount();
            },
            getContractGoodsItem(vendorId, skuId, contractId, callBack){
                let bizFormId = this.bizFormId != null ? this.bizFormId : -1;
                let bizAreaId = this.bizAreaId != null ? this.bizAreaId : -1;
                let postData = {
                    vendorId: vendorId,
                    skuId: skuId,
                    bizAreaId: bizAreaId,
                    bizFormId: bizFormId,
                    contractId: contractId,
                };
                devcReqrApi.getContractGoodsItem(postData, function (result) {
                    if(result.type == "info") {
                        callBack(result.data);
                    } else {
                        callBack(null);
                    }
                })
            },
            getDlgResult: function () {
                let result = {};
                //
                let self = this;
                this.$refs['goodsItemList'].validate(function (valid) {
                    if(valid) {
                        let quantityValid = true;
                        let goodsItemList = self.requireVoucher.goodsItemList || [];
                        for(let i = 0; i < goodsItemList.length; i++) {
                            let goodsItem = goodsItemList[i];
                            if(!Utils.isTrue(goodsItem.onlyForAsmblAcc)) {
                                if(Utils.isNoB(goodsItem.quantity)) {
                                    quantityValid = false;
                                } else {
                                    if(!Utils.isNumber(goodsItem.quantity) || goodsItem.quantity < 0) {
                                        quantityValid = false;
                                    }
                                }

                            }
                        }
                        if(quantityValid) {
                            result.type = 'info';
                            result.data = goodsItemList;
                        } else {
                            result.type = 'warn';
                            result.message = "申请数量不能为空";
                        }
                    } else {
                        result.type = 'warn';
                        result.message = "校验失败";
                    }
                });
                return result;
            },
            selectCentBuyMode: function (index) {
                let requireVoucher = this.requireVoucher;
                let goodsItemList = requireVoucher.goodsItemList;
                let goodsItem = goodsItemList[index];
                let itemList = goodsItem.itemList || [];
                itemList.forEach(function (item) {
                    item.centBuyMode = goodsItem.centBuyMode;
                });
                goodsItem.itemList = Utils.merge([], itemList);
                this.requireVoucher.goodsItemList = Utils.merge([], goodsItemList);
            },

            // 选择对应的组装件
            addAsmblAcc: function (index) {
                let self = this;
                let requireVoucher = this.requireVoucher;
                let goodsItemList = requireVoucher.goodsItemList;
                let goodsItem = goodsItemList[index];
                let assetDefId = goodsItem.assetDefId;
                // 选择对应的组装件
                let itemList = goodsItem.itemList || [];
                let checkIds = itemList.pluck("accDefId");
                // 查询对应的组装件ids
                devcDefApi.getMerchtDevcAccAsmblRelAccDefIdByDevcDefId({devcDefId: assetDefId}, function (result) {
                    if(result.type == "info") {
                        let accDefIds = result.data || [];
                        if(accDefIds.length > 0) {
                            let params = {
                                filter: {
                                    ids: accDefIds,
                                },
                                checkIds: checkIds,
                                needDisabled: true
                            };
                            // 选择组装件
                            showAsmblAccDefSelectDlg(params, function (accResult, theDlg) {
                                theDlg.close();
                                let resultData = accResult || [];
                                let ids = resultData.pluck("id");
                                // 根据组装件信息查询对应的入选商品信息
                                let postData = {
                                    devcDefId: assetDefId,
                                    assetDefIds: ids,
                                    bizAreaId: self.bizAreaId,
                                    bizFormId: self.bizFormId,
                                    vendorId: goodsItem.vendorId
                                };
                                devcReqrApi.getRequireGoodsAsmblItemListByFilter(postData, function (rsultAcc) {
                                    if(rsultAcc.type == "info") {
                                        let accList = rsultAcc.data || [];
                                        if(accList.length > 0) {
                                            let quantity = 0;
                                            accList.forEach(function (item) {
                                                quantity = quantity + item.quantity;
                                                item.setQuantity = item.quantity;
                                                item.wtxAmount = (parseFloat(item.price || 0) * parseInt(item.quantity || 0)).toFixed(2);
                                            });
                                            goodsItem.asmblAccReqCount = goodsItem.asmblAccReqCount + quantity;
                                            goodsItem.asmblAccSetCount = goodsItem.asmblAccSetCount + quantity;
                                            goodsItem.itemList = Utils.merge([], itemList.concat(accList));
                                            goodsItemList = Utils.merge([], goodsItemList);
                                            self.requireVoucher.goodsItemList = goodsItemList;
                                            // 包含组装件总数
                                            self.countTotalAsmblAccSetCount();
                                            // 计算含税总金额
                                            self.calWtxAmount();
                                        }
                                    } else {
                                        MsgBox.warning(rsultAcc.message);
                                    }

                                })
                            })
                        } else {
                            MsgBox.warning("请先关联组装件");
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 虚拟资产添加组装件
            addAsmblAccForVirtual: function (index) {
                let self = this;
                let goodsItemList = self.requireVoucher.goodsItemList || [];
                let itemList = goodsItemList[index].itemList || [];
                //
                let itemIds = itemList.pluck('deviceId');
                let filter = {
                    contractRealComId: self.requireVoucher.requireRealComId,
                    asmblAccFlag: true,
                    contractEnded: false,
                    assetDefFlag: true,
                    forReq: true, // 标准合同为contractRealComId 的 或 框架合同 或 无合同
                    skuFlag: true, // 关联sku
                };
                if(self.bizFormId != null && self.bizFormId != -1) {
                    filter.bizFormIds = [self.bizFormId, -1];
                }
                let params = {};
                params.checkIds = itemIds;
                params.filter = filter;
                goodsInSelectGroupDlg(params, function (result) {
                    let adoptedDeviceList = result || [];
                    adoptedDeviceList.forEach(function (adoptedDevice) {
                        let item = {};
                        item.deviceId = adoptedDevice.id;
                        item.devcTitle = adoptedDevice.devcTitle;
                        item.devcName = adoptedDevice.devcName;
                        item.devcCatName = adoptedDevice.devcCatName;
                        item.devcBrandName = adoptedDevice.devcBrandName;
                        item.devcModel = adoptedDevice.devcModel;
                        item.devcFixedSpec = adoptedDevice.devcFixedSpec;
                        item.devcUnit = adoptedDevice.devcUnit;
                        item.accDefNo = adoptedDevice.innerCode;
                        item.accDefId = adoptedDevice.assetDefId;
                        //
                        item.name = adoptedDevice.name;
                        item.asmblAccFlag = adoptedDevice.asmblAccFlag;
                        item.centBuyMode = adoptedDevice.centBuyMode;
                        item.reqCentBuyMode = adoptedDevice.centBuyMode;
                        item.skuId = adoptedDevice.skuId;
                        item.title = adoptedDevice.title;
                        item.bizAreaCode = adoptedDevice.bizAreaCode;
                        item.bizFormCode = adoptedDevice.bizFormCode;
                        item.vendorName = adoptedDevice.vendorName;
                        item.vendorRealComId = adoptedDevice.vendorRealComId;
                        item.vendorRealComName = adoptedDevice.vendorRealComName;
                        item.vendorRealComCode = adoptedDevice.vendorRealComCode;
                        item.vendorId = adoptedDevice.vendorId;
                        if(Utils.isTrue(adoptedDevice.contractEnded)) {
                            item.contractId = -1;
                        } else {
                            item.contractTitle = adoptedDevice.contractTitle;
                            item.contractId = adoptedDevice.contractId;
                            item.contractDateStart = adoptedDevice.contractDateStart;
                            item.contractDateEnd = adoptedDevice.contractDateEnd;
                        }
                        item.model = adoptedDevice.model;
                        item.fixedSpec = adoptedDevice.fixedSpec;
                        item.modelSpec = adoptedDevice.modelSpec;
                        item.price = adoptedDevice.price;
                        item.oldPrice = adoptedDevice.price;
                        item.ntxPrice = adoptedDevice.ntxPrice;
                        item.taxRate = adoptedDevice.taxRate;
                        item.wrntPeriod = adoptedDevice.wrntPeriod;
                        item.arriveDays = adoptedDevice.arriveDays;
                        item.goodsCatName = adoptedDevice.goodsCatName;
                        item.goodsBrandName = adoptedDevice.goodsBrandName;
                        item.unit = adoptedDevice.unit;
                        item.quantity = 1;
                        item.wtxAmount = (parseFloat(item.price || 0) * parseInt(item.quantity)).toFixed(2);
                        //
                        if(itemIds.indexOf(item.deviceId) < 0) {
                            itemList.push(item);
                        }
                    });
                    goodsItemList[index].itemList = Utils.merge([], itemList);
                    self.requireVoucher.goodsItemList = Utils.merge([], goodsItemList);
                    // 计算含税总金额
                    self.calWtxAmount();
                    // 包含组装件总数
                    self.countTotalAsmblAccSetCount();
                });
            },
        }
    }
</script>
<style>
    .el-table .row-expand-cover .cell .el-table__expand-icon {
        display: none;
    }
</style>




// WEBPACK FOOTER //
// src/compo/retailer/DeviceRequireVoucherUpdate.vue